import { render, staticRenderFns } from "./vector.component.vue?vue&type=template&id=01caef71&scoped=true&"
import script from "./vector.component.vue?vue&type=script&lang=js&"
export * from "./vector.component.vue?vue&type=script&lang=js&"
import style0 from "./vector.component.vue?vue&type=style&index=0&id=01caef71&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01caef71",
  null
  
)

export default component.exports